//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dicOption } from '@/option/config';
export default {
  data: function data() {
    return {
      dicOption: dicOption
    };
  },
  inject: ["main"]
};